export const borderRadius = {
  small: '0.25rem',
  medium: '0.5rem',
  large: '1rem',
  rounded: '50%',
};
